import { useTheme } from "@mui/material";
import { createSxStyles } from "../../common/createSxStyles";

export const useLanguageMenuStyle = () => {
    const theme = useTheme();
    return createSxStyles({
        splitter: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        language: {
            cursor: "pointer",
            "&:hover": {
                color: theme.palette.text.primary,
            },
        },
        activeLanguage: {
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.main,
        },
    });
};
